import _values from 'lodash/values';

const fieldLayouts = {
  TOP:      'template:common:form:field.vertical.top',
  CENTERED: 'template:common:form:field.vertical.center',
  HYBRID:   'template:common:form:field.vertical.hybrid',
  LEFT:     'template:common:form:field.horizontal.left',
};

const seImgPath = `${App.globalContext.assetURL}c/img/screen-designer/section-editor`;

const fieldLayoutsList = [
  {
    text:   'Left Aligned',
    byline: 'Left-aligned labels and inputs',
    image:  seImgPath + '/layout-form-top.svg',
    value:  fieldLayouts.TOP,
  },
  {
    text:   'Centered Layout',
    byline: 'All form elements centered',
    image:  seImgPath + '/layout-form-center.svg',
    value:  fieldLayouts.CENTERED,
  },
  {
    text:   'Hybrid',
    byline: 'Centered fields with left-aligned labels',
    image:  seImgPath + '/layout-form-hybrid.svg',
    value:  fieldLayouts.HYBRID,
  },
];

const fieldLayoutsAll = _values(fieldLayouts);

export { fieldLayouts, fieldLayoutsList, fieldLayoutsAll };

export default fieldLayouts;
